import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Contact from "@/components/Contact";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Contact />
    </div>
  );
};

export default NotFound;
